// 用户信息
export const userInfoKey = {
  all: ['userInfoKey'] as const,
};
